// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonBatterySpeakerOffColored_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.99982 12.9997H11.9997L9.99977 18.9996H7.99982V12.9997Z" fill="#ED5353"/>
  <path d="M25.9994 8.99979H3.99991V22.9995H12.9997V20.9995H5.99986V10.9997H23.9995V12.4997L25.971 13.4855L25.9994 13.4684V16.9996H27.9994V11.9997L25.9994 10.9997V8.99979ZM23.9995 16.9996L18.9996 19.9995H14.9997V26.9994H18.9996L23.9995 29.9993V16.9996ZM21.2201 20.9995H21.222L19.5535 22.0006H16.9996V24.9994H19.5535L21.9995 26.467V20.5319L21.2201 20.9995ZM30.5858 26.3434L29.1717 24.9293L27.7575 26.3434L26.3433 24.9293L27.7575 23.5151L26.3433 22.1009L27.7575 20.6867L29.1717 22.1009L30.5858 20.6867L32 22.1009L30.5858 23.5151L32 24.9293L30.5858 26.3434Z" class="svg-bg"/>
  <path d="M25.9994 8.99979H3.99991V22.9995H12.9997V20.9995H5.99986V10.9997H23.9995V12.4997L25.971 13.4855L25.9994 13.4684V16.9996H27.9994V11.9997L25.9994 10.9997V8.99979ZM23.9995 16.9996L18.9996 19.9995H14.9997V26.9994H18.9996L23.9995 29.9993V16.9996ZM21.2201 20.9995H21.222L19.5535 22.0006H16.9996V24.9994H19.5535L21.9995 26.467V20.5319L21.2201 20.9995ZM30.5858 26.3434L29.1717 24.9293L27.7575 26.3434L26.3433 24.9293L27.7575 23.5151L26.3433 22.1009L27.7575 20.6867L29.1717 22.1009L30.5858 20.6867L32 22.1009L30.5858 23.5151L32 24.9293L30.5858 26.3434Z" class="svg-fg-stroke"/>
</svg>
`;
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M38 15H8V33H25V31H10V17H36V19.5L38 20.5V23.5965L40 22.2632V19L38 18V15Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 30H27V38H32L38 42V26L32 30ZM36 29.737V38.263L32.6056 36H29V32.0002H32.6056L36 29.737Z" class="svg-bg"/>
  <path d="M41.5355 30.4645L43.6569 32.5858L45.7782 30.4645L47.1924 31.8787L45.0711 34L47.1924 36.1213L45.7782 37.5355L43.6569 35.4142L41.5355 37.5355L40.1213 36.1213L42.2426 34L40.1213 31.8787L41.5355 30.4645Z" class="svg-bg"/>
  <path d="M12 19H18L15 29H12V19Z" fill="#ED5353"/>
</svg>
`;
/**
 * IconCommonBatterySpeakerOffColored is a generated icon component.
 */
let IconCommonBatterySpeakerOffColored = IconCommonBatterySpeakerOffColored_1 = class IconCommonBatterySpeakerOffColored extends IconBaseElement {
    render() {
        return html `${IconCommonBatterySpeakerOffColored_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonBatterySpeakerOffColored.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconCommonBatterySpeakerOffColored = IconCommonBatterySpeakerOffColored_1 = __decorate([
    customElement('zui-icon-common-battery-speaker-off-colored')
], IconCommonBatterySpeakerOffColored);
export { IconCommonBatterySpeakerOffColored };
